import React, { ReactElement } from "react";
import { PdfRender } from "@timhortons/common/src/components/molecules/pdfRenderer";
interface Props {}
const privacy = require("../../assets/privacy.pdf");
export default function index(props: Props): ReactElement {
  return (
    <React.Fragment>
      <PdfRender pdfStyles={{ display: "flex", height: "100%", width: "100%" }} url={privacy} />
    </React.Fragment>
  );
}
